import { useAuth } from '@/contexts/AuthContext';

// Custom hook to access subscription data specifically
export const useSubscription = () => {
  const { subscription, checkSubscription } = useAuth();
  
  return {
    subscription,
    checkSubscription,
    isSubscribed: subscription?.subscribed || false,
    subscriptionTier: subscription?.subscription_tier,
    creditsRemaining: subscription?.credits_remaining || 0,
    creditsPerPeriod: subscription?.credits_per_period || 0,
    creditsUsed: subscription?.credits_used_this_period || 0,
    periodEnd: subscription?.current_period_end,
  };
};